import { apiGet, apiPost, queryString, type ApiResult } from "./client";
import type { MyLesson, MyWeek, NotificationsPage } from "./types";

export async function fetchMyLessons(from: string, to: string): Promise<ApiResult<MyLesson[]>> {
  return apiGet<MyLesson[]>("/me/lessons" + queryString({ from, to }));
}

export async function fetchMyWeek(from: string): Promise<ApiResult<MyWeek>> {
  return apiGet<MyWeek>("/me/week" + queryString({ from }));
}

export async function fetchNotifications(page: number, unreadOnly: boolean): Promise<ApiResult<NotificationsPage>> {
  return apiGet<NotificationsPage>("/me/notifications" + queryString({ page, unreadOnly }));
}

export async function fetchUnreadCount(): Promise<ApiResult<{ count: number }>> {
  return apiGet<{ count: number }>("/me/notifications/unread-count");
}

export async function markNotificationRead(id: string): Promise<ApiResult<null>> {
  return apiPost<null>(`/me/notifications/${id}/read`, undefined);
}

export async function markAllNotificationsRead(): Promise<ApiResult<null>> {
  return apiPost<null>("/me/notifications/read-all", undefined);
}
